import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.daily.vip_deposit,
    (task) => {
        return {
            task
        }
    }
) 